import toast from "react-hot-toast";
import { validateEmail } from "./validate-email";

export const handleWaitlist = async (email, waitlist_id) => {
  if (!validateEmail(email)) {
    toast.error("The email is invalid");
    return;
  }

  const waitlistResponse = await fetch("/api/signup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      waitlist_id: waitlist_id,
      referral_link: window.location.href,
      metadata: { source: "landing_page" },
      answers: [],
    }),
  });

  // const emailResponse = await fetch("/api/mail", {
  //   method: "POST",
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  //   body: JSON.stringify({
  //     email,
  //     type: "waitlist",
  //     subject: "Welcome to ExtensionFast. Let’s build your extension! ⚡",
  //   }),
  // });

  if (waitlistResponse.ok)
    // && emailResponse.ok)
    toast.success("You've joined the waitlist: " + email);
  else toast.error("There was an issue signing up for the waitlist");
};
